module.exports = __webpack_public_path__ + "img/idea_02.dcdeb5f4.png";